import { connectMenu } from 'instantsearch.js/es/connectors';

// create the render function
const renderMenuSelect = (renderOptions, isFirstRender) => {
    const {
        items,
        canRefine,
        refine,
        widgetParams,
    } = renderOptions;

    if (isFirstRender) {
        const select = document.createElement('select');
        select.setAttribute('name', widgetParams.attribute);
        select.classList.add('pl-4', 'pr-12', 'bg-transparent', 'border-none', '[field-sizing:content]');
        select.addEventListener('change', (event) => {
            refine(event.target.value);
        });

        widgetParams.container.appendChild(select);
    }

    const select = widgetParams.container.querySelector('select');

    select.disabled = !canRefine;

    select.innerHTML = `
        <option value="">${widgetParams.allLabel !== undefined ? widgetParams.allLabel : '-'}</option>
        ${items
        .map((item) => `
            <option
                value="${item.value}"
                ${item.isRefined ? 'selected' : ''}>${item.label}</option>
        `).join('')}
    `;
};

// create the custom widget
const customMenuSelectCategory = connectMenu(renderMenuSelect);

export default customMenuSelectCategory;
